import { Component, Input, OnInit } from '@angular/core';
import { EmitterService } from '../../../../../core/utility/services/emitter.service';
import { DownloadConfig } from '../../../../analytics-core/interfaces/widget.interface';
import { EVENT_EMITTERS } from '../../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../../analytics/services/analytics.service';
import { NavItemComponent } from '../nav-item/nav-item.component';
import { AnalyticsMixpanelService } from '../../../../analytics/services/analytics.mixpanel.service';

@Component({
	selector: 'app-nav-link',
	styleUrls: ['./nav-link.component.css'],
	templateUrl: './nav-link.component.html'
})
export class NavLinkComponent extends NavItemComponent implements OnInit {
	@Input() downloadconfig: any;
	@Input() downloadcsvcolumns: any;
	public downloadConfiguration: DownloadConfig;
	public isR6: boolean = false;
	public isR11: boolean = false;

	constructor(
		protected analyticsDataModel: AnalyticsDataModel,
		protected analyticsService: AnalyticsService,
		protected analyticsMixpanelService: AnalyticsMixpanelService
	) {
		super(analyticsDataModel, analyticsService, analyticsMixpanelService);
	}

	ngOnInit(): void {
		super.ngOnInit();
		this.isR6 = this.analyticsDataModel.config.version.toLowerCase() == 'r6' ? true : false;
		this.isR11 = this.analyticsDataModel.config.version.toLowerCase() == 'r11' ? true : false;
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.downloadcsvcolumns = this.downloadcsvcolumns ? JSON.parse(decodeURI(this.downloadcsvcolumns)) : [];
	}

	navigateAwayIfPathDisabled(): void {
		if (this.isDisabled && this.isActive) {
			EmitterService.get(EVENT_EMITTERS.NAVIGATE).emit({ name: this.analyticsDataModel.config.routing.defaultRoute });
		}
	}

	downloadCSV(e: any): void {
		e.preventDefault();
		const colConfig =
			this.downloadConfiguration && this.downloadConfiguration.columnsConfig
				? this.downloadConfiguration.columnsConfig
				: this.downloadcsvcolumns
				? this.downloadcsvcolumns
				: [];
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName,
			colConfig
		);
	}
}
